import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Vacaciones} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiVacService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** vacaciones ***/

  getVacaciones(): Promise<Vacaciones[]> {
    const url = `${this.apiUrl}vacaciones`;
    return firstValueFrom(this.http.get<Vacaciones[]>(url))
  }
  getVacacionesAlumno(id: number): Promise<Vacaciones[]> {
    const url = `${this.apiUrl}vacaciones/byalumno/${id}`;
    return firstValueFrom(this.http.get<Vacaciones[]>(url))
  }
  borrarVacaciones(idAlumno: number, curso: string): Promise<void> {
    const url = `${this.apiUrl}vacaciones/${curso}/${idAlumno}`;
    return firstValueFrom(this.http.delete<void>(url))
  }

}
